import { fetchApi } from 'Utils/utils';

let findByUrl = function(params) {
  return fetchApi.get(`/api/v1/pages/url/${params}/`);
};

export { findByUrl };
